export type ProcessStep = {
  id: string;
  number: string;
  title: string;
  summary: string;
  description: string;
  details: string[];
};

export const processSteps: ProcessStep[] = [
  {
    id: 'discovery-call',
    number: '1',
    title: 'Discovery Call',
    summary: 'Learn your Business, Pain Points, and Goals',
    description:
      'We start with a focused conversation — not a sales pitch marathon. You walk us through your daily work life: who does what, where time is lost, and what “success” looks like for your team. We leave with a clear picture of constraints, tools and processes, and what headaches need resolved the most.',
    details: [
      'Map stakeholders, tools, and current handoffs',
      'Identify the busiest pain points and success metrics',
      'Confirm scope fit and next-step options',
    ],
  },
  {
    id: 'process-audit',
    number: '2',
    title: 'Process Audit',
    summary: 'Understand Processes and Find the Biggest Time-wasters',
    description:
      'Next we dig into the real workflows — the screens, inboxes, CRMs, spreadsheets, and the parts that cost time. The goal is prioritization: which automations free the most hours with the least operational risk, and how we can give you your time back.',
    details: [
      'Shadow Key Operations and Workflows',
      'Locate Pain Points and Burdensome Processes',
      'Identify Data Systems and Collection Points',
    ],
  },
  {
    id: 'custom-strategy',
    number: '3',
    title: 'Tailored Strategy',
    summary: 'A Tailored Plan with Timelines',
    description:
      'We turn discovery into a practical build plan: present a timeline, set up checkpoints and check-ins, and determine support. We build a timeline and begin development while providing updates at each checkpoint.',
    details: [
      'Phased Roadmap with Checkpoints',
      'Determine Integration Approach',
      'Build Proof Of Concept',
    ],
  },
  {
    id: 'build-implement',
    number: '4',
    title: 'Build & Implement',
    summary: 'Deliver Built Processes and Integrate Into Real Operations',
    description:
      'We build and implement against live workflows, wire integrations, and solidify the path to delivery. Expect functioning automations in your work environment — with logging, failure monitors, and checkpoints controlled by you to ensure accuracy.',
    details: [
      'Import automations to be a tool in your daily processes',
      'Trial run and adjustments on feedback',
      'Error Monitoring, failure protection, and logging',
    ],
  },
  {
    id: 'train-support',
    number: '5',
    title: 'Train & Support',
    summary: 'Prepare the Team for Long-term Success',
    description:
      'These tools only promote long-term success and fluidity if used appropriately by the team they support. We prepare and train for the usage of these processes, then release them to a live build. Continued support and monitoring from our team helps ensure the tools are implemented and your time is saved.',
    details: [
      'Provided training and knowledgebase',
      'Ongoing tuning and refinement for success',
      'Handoff of ownership and handoff paths',
    ],
  },
];
